<template>
  <div @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div >Tuition</div>
    <div>
      <div v-if="active">
        <apexchart width="400" type="bar" :options="options" :series="series"></apexchart>
      </div>
      <div v-else class="content">
        <img src="../assets/pqc3.jpg">
        <div class="text"><h1>Tuition</h1></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
   return {
    active: false,
    options: {
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ['Paul Quinn College', 'UT-Austin', 'Texas A&M', 'UT-Dallas', 'Rice University'], 
        title: {
          text: 'Colleges in Texas', 
        }
      }, 
      yaxis: {
        title: {
        text: 'Tuition ($)'
        }
      },
    },
    series: [{
      name: 'Tuition',
      data: [9125, 10824, 12153, 13442, 50310],
      }], 
    }      
  },
  methods: {
    mouseOver: function() {
      this.active = true;
    },
    mouseLeave: function() {
      this.active = false;
    }
  },
};
</script>
<style scoped>
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  word-wrap: break-word;
}

.content {
  text-align: center;
  position: relative;
}

.img {
  min-width: 100%;
}
</style>